<template>
  <div class="Com_12">
    <title1 type="2" title="工单处理情况"> </title1>
    <div class="Com_12_bottom" style="width: 570px; height: 394px">
      <MyEcharts v-if="showcdata" :id="'Com_12'" :options="cdata" />
    </div>
  </div>
</template>
    
    <script>
import title1 from "@/views/exposition/components/title3";
import { dataInterface } from "@/api/dataInterfaceApi";
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import * as echarts from "echarts5";
export default {
  components: {
    title1,
    MyEcharts
  },
  data() {
    return {
      showcdata: false,
      cdata: {
        //
        tooltip: {
          trigger: "axis",
        },
		grid: {
		  top: "23%",
		  fontSize: 19
		},
        legend: {
          itemWidth: 12,
          itemHeight: 8,
          data: ["已处理", "未处理"],
        },
        xAxis: {
          data: ["10/14", "10/15", "10/16", "10/17", "10/18", "10/19", "10/20"],
          splitLine: {
            show: false,
          },
          axisLabel: {
              interval: 0,
              formatter: function (value) {
                console.log(value, "拼接加\n返回的类目项");
                var ret = ""; //拼接加\n返回的类目项
                var maxLength = 5; //每项显示文字个数
                var valLength = value.length; //X轴类目项的文字个数
                var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
                if (rowN > 1) {
                  //如果类目项的文字大于5,
                  for (var i = 0; i < rowN; i++) {
                    var temp = ""; //每次截取的字符串
                    var start = i * maxLength; //开始截取的位置
                    var end = start + maxLength; //结束截取的位置
                    //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                    temp = value.substring(start, end) + "\n";
                    ret += temp; //凭借最终的字符串
                  }
                  return ret;
                } else {
                  return value;
                }
              },
            },
        },
        yAxis: {
          name: "单位: 条",
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "已处理",
            type: "bar",
            barWidth: 17,
            stack: "使用情况",
            data: [705, 720, 736, 710, 710, 720, 730],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#FFCE51",
                  },
                  {
                    offset: 1,
                    color: "#2E4039",
                  },
                ]),
              },
            },
          },
          {
            name: "未处理",
            type: "bar",
            stack: "使用情况",
            data: [505, 520, 536, 510, 510, 520, 535],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  1,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: "#0B4C5D", // 0% 处的颜色
                    },
                    {
                      offset: 0.6,
                      color: "#0C809D", // 60% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#0DB9E5", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.$bus.$on("onfangdiangonglv", () => {
      this.getBattery24hours();
    });
    this.getBattery24hours();
  },
  destroyed() {
    // this.$bus.$off('onfangdiangonglv')
  },
  methods: {
    //获取24小时电次数分布
    getBattery24hours() {
      let params = {
        "enCode": "zngf-dz-gongdan-chuli-qingkuang",// 接口code
            "@station_id": localStorage.getItem('guangfuStationId') ? localStorage.getItem('guangfuStationId') : "320500H001" // 接口传参
      };
      this.showcdata = false;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "time1");
          if (res) {
            let data = [];
            let data2 = [];
            let xAxis = [];
            res.forEach((item) => {
              xAxis.push(this.insertNewlineEvery5Characters(item.snap_day));
              data.push(item.ycl);
              data2.push(item.wcl);
            });
            this.cdata.xAxis.data = xAxis;
            this.cdata.series[0].data = data;
            this.cdata.series[1].data = data2;
            this.showcdata = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    insertNewlineEvery5Characters(str) {
      var result = "";
      for (var i = 0; i < str.length; i++) {
        result += str[i];
        if ((i + 1) % 6 === 0) {
          result += "\n";
        }
      }
      return result;
    },
  },
};
</script>
    
  <style lang="scss" scoped>
.Com_12 {
  .Com_12_bottom {
    // background: red;
  }
}
</style>